import {Component, Input} from '@angular/core';

@Component({
    selector: 'cat',
    templateUrl: './cat.component.html',
    styleUrls: [
        './cat.component.less']

})
export class CatComponent{

    @Input() skin : string;

    constructor() {}

}

